import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { sanityClient } from "../lib/sanityClient";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

function CarServicePage() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const { lang } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const query = `*[_type == "carService"]{
          _id,
          title,
          description,
          priceRange,
          mechanics[]->{_id, name, yearsOfExperience},
          primaryImage,
          additionalImages
        }`;

        const fetchedServices = await sanityClient.fetch(query);
        setServices(fetchedServices);
      } catch (error) {
        console.error("Error fetching car services:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>{t("carService.pageTitle")}</title>
        <meta
          name="description"
          content={t("carService.metaDescription")}
        />
        <link rel="canonical" href='https://237mechanic.com/cm/en/car-servicing'/>

      </Helmet>

      <h1 className="text-3xl font-bold text-center mb-6">
        {t("carService.heading")}
      </h1>
      <p className="text-lg text-gray-600 text-center mb-8">
        {t("carService.intro")}
      </p>

      {loading ? (
        <p className="text-center text-gray-500">{t("loading")}</p>
      ) : services.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <div key={service._id} className="border rounded-lg p-4 shadow-lg">
              {service.primaryImage && (
                <img
                  src={service.primaryImage}
                  alt={service.title[lang] || service.title.en}
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
              )}
              <h2 className="text-xl font-semibold">
                {service.title[lang] || service.title.en}
              </h2>
              <p className="text-gray-600 mt-2">
                {service.description[lang] || service.description.en}
              </p>
              <p className="text-blue-600 font-medium mt-2">
                {t("carService.priceRange")}: {service.priceRange}
              </p>
              <h3 className="font-semibold mt-4">{t("carService.mechanics")}</h3>
              <ul className="list-disc list-inside text-gray-700">
                {service.mechanics?.map((mechanic) => (
                  <li key={mechanic._id}>
                    {mechanic.name} ({mechanic.yearsOfExperience} {t("carService.years")})
                  </li>
                ))}
              </ul>
              {service.additionalImages?.length > 0 && (
                <div className="mt-4">
                  <h3 className="font-semibold">{t("carService.moreImages")}</h3>
                  <div className="flex space-x-2 overflow-auto">
                    {service.additionalImages.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt={`${service.title[lang] || service.title.en} ${index + 1}`}
                        className="w-20 h-20 object-cover rounded-md"
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-500">
          {t("carService.noServices")}
        </p>
      )}
    </div>
  );
}

export default CarServicePage;
